import angular from 'angular'
import formvalidate from './formvalidate'
import formvalidateApi from './formvalidateApi'
import validator from './validator'

export default angular
    .module('app.formvalidate', [])
    .directive('formvalidate', formvalidate)
    .service('formvalidateApi', formvalidateApi)
    .factory('validator', validator)
    .name



// WEBPACK FOOTER //
// ./src/components/formvalidate/index.js